// proposal-api's `stable_id` (cpq/lines.py): uuid5 of the ':'-joined parts in
// this namespace. CPQ and proposal-api mint the same id for the same row, so
// two initializers of one quote collide on the key instead of each adding a row.
const PROPOSAL_API_ID_NAMESPACE = '5b2f6c1e-8f4a-4a52-9a6e-1c2d3e4f5a6b'

export async function stableId(...parts: string[]) {
  const namespace = Uint8Array.from(PROPOSAL_API_ID_NAMESPACE.replaceAll('-', '').match(/../g)!, (byte) =>
    Number.parseInt(byte, 16)
  )
  const name = new TextEncoder().encode(parts.join(':'))
  const data = new Uint8Array(namespace.length + name.length)
  data.set(namespace)
  data.set(name, namespace.length)
  const bytes = new Uint8Array(await crypto.subtle.digest('SHA-1', data)).slice(0, 16)
  bytes[6] = (bytes[6] & 0x0f) | 0x50
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
